import { OpeningStateEnum } from '@src/graphql/generated';

export function isDraft(state?: OpeningStateEnum): boolean {
  return !!state && OpeningStateEnum.DRAFT === state;
}

export function isPaused(state?: OpeningStateEnum): boolean {
  return !!state && OpeningStateEnum.PAUSED === state;
}

export function isActive(state?: OpeningStateEnum): boolean {
  return !!state && OpeningStateEnum.ACTIVE === state;
}

export function isArchived(state?: OpeningStateEnum): boolean {
  return !!state && OpeningStateEnum.ARCHIVED === state;
}

export function isAdminReview(state?: OpeningStateEnum): boolean {
  return !!state && OpeningStateEnum.ADMIN_REVIEW === state;
}

export function isInactive(state?: OpeningStateEnum): boolean {
  return !!state && OpeningStateEnum.INACTIVE === state;
}

export function getStatus(state: OpeningStateEnum): string {
  if (isActive(state)) {
    return 'active';
  } else if (isAdminReview(state)) {
    return 'review';
  } else if (isInactive(state)) {
    return 'inactive';
  } else if (isArchived(state)) {
    return 'archived';
  } else if (isDraft(state)) {
    return 'draft';
  } else if (isPaused(state)) {
    return 'paused';
  } else {
    return '';
  }
}

export function printStatus(state: OpeningStateEnum): string {
  if (isActive(state)) {
    return 'Published';
  } else if (isAdminReview(state)) {
    return 'In review';
  } else if (isInactive(state)) {
    return 'Stopped';
  } else if (isArchived(state)) {
    return 'Archived';
  } else if (isDraft(state)) {
    return 'Draft';
  } else if (isPaused(state)) {
    return 'Paused';
  } else {
    return '';
  }
}
